import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import Button from '@atlaskit/button';
// eslint-disable-next-line check-choreographer-usage/no-import-in-product-messages-without-choreographer
import Popup from '@atlaskit/popup';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { token } from '@atlaskit/tokens';

import { PRIMARY_COLORS } from '../colors.ts';

import { ContentStateMaker } from './ContentStateMaker.tsx';
import type { CreateNewContentStateButtonProps } from './types.ts';
import { i18n } from './i18n.ts';

const CreateContentStateButtonComponent = ({
	spaceKey,
	isDisabled,
	onCreateState,
	intl: { formatMessage },
}: CreateNewContentStateButtonProps) => {
	const [isCreateButtonSelected, setIsCreateButtonSelected] = useState<boolean>(false);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const onClick = () => {
		setIsCreateButtonSelected((prevIsCreateButtonSelected) => !prevIsCreateButtonSelected);
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'button',
				objectId: spaceKey,
				actionSubjectId: 'adminCreateStatusButtonClicked',
				source: 'contentStateAdminSettings',
			},
		}).fire();
	};

	const closePopup = () => {
		setIsCreateButtonSelected(false);
	};

	return (
		<Popup
			autoFocus={false}
			isOpen={isCreateButtonSelected}
			onClose={closePopup}
			content={() => (
				<ContentStateMaker
					spaceKey={spaceKey}
					closePopup={closePopup}
					color={PRIMARY_COLORS.PURPLE} // when creating a new status, default selected color is purple
					onSave={onCreateState}
				/>
			)}
			placement="right-end"
			trigger={(triggerProps) => (
				<Button
					{...triggerProps}
					testId="create-state-button"
					isSelected={isCreateButtonSelected}
					onClick={onClick}
					style={{
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						marginLeft: token('space.100'),
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						marginTop: token('space.100'),
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						paddingLeft: token('space.1000'),
						// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
						paddingRight: token('space.1000'),
					}}
					isDisabled={isDisabled}
				>
					{formatMessage(i18n.createStatus)}
				</Button>
			)}
		/>
	);
};

export const CreateContentStateButton = injectIntl(CreateContentStateButtonComponent);
